import React, { useEffect, useRef, useState } from "react";
import GoogleMapReact from "google-map-react";
import MOModalWrapper from "../../../../components/commons/MOModalWrapper";
import MOButtonV2 from "../../../../components/commons/MOButtonV2";
import mobioApi from "../../../../services";
import { toastMessage } from "../../../../helpers/toastMessage";

const NoShowReportModal = ({
  token,
  modalOpen,
  setModalOpen,
  eventDetail,
  bookingDetail,
  loading,
  apiCall = () => {},
}) => {
  const apiKey = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

  const [coordinates, setCoordinates] = useState({
    lat: 52.367925,
    lng: 4.846423,
  });

  // --- New States ---
  const [reason, setReason] = useState("");
  const [images, setImages] = useState([]);

  const [mapInstance, setMapInstance] = useState(null);
  const [mapsInstance, setMapsInstance] = useState(null);
  const markerRef = useRef(null);
  const fileInputRef = useRef(null);

  const zoom = 11;

  const handleApiLoaded = ({ map, maps }) => {
    setMapInstance(map);
    setMapsInstance(maps);

    markerRef.current = new maps.Marker({
      position: coordinates,
      map,
      draggable: true,
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
        scaledSize: new maps.Size(40, 40),
      },
    });

    markerRef.current.addListener("dragend", (event) => {
      setCoordinates({
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      });
    });
  };

  useEffect(() => {
    if (markerRef.current) markerRef.current.setPosition(coordinates);
    if (mapInstance) mapInstance.panTo(coordinates);
  }, [coordinates]);

  const handleMapClick = ({ lat, lng }) => setCoordinates({ lat, lng });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCoordinates((prev) => ({ ...prev, [name]: parseFloat(value) || 0 }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages((prev) => [...prev, ...newImages]);

    e.target.value = null;
  };

  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const uploadImageToAWS = (file) => {
    return new Promise(async (resolve, reject) => {
      try {
        const formData = new FormData();
        formData.append("image", file);
        const api = mobioApi(token);
        const response = await api.upload(formData);
        resolve(response.data.url);
      } catch (error) {
        toastMessage("error", "Error in uploading file");
        reject(error);
      }
    });
  };

  return (
    <MOModalWrapper
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      className={"map-event-modal"}
      title={
        <>{`${eventDetail?.split("_").join(" ")} trigger from system manually`}</>
      }
    >
      <div className="manual-event-trigger-no-show-container">
        <div className="manual-event-trigger-no-show-row">
          <div className="airport-service-level-fields">
            <label>Latitude</label>
            <input
              type="number"
              name="lat"
              value={coordinates.lat}
              onChange={handleInputChange}
            />
          </div>

          <div className="airport-service-level-fields">
            <label>Longitude</label>
            <input
              type="number"
              name="lng"
              value={coordinates.lng}
              onChange={handleInputChange}
            />
          </div>

          {/* Reason Input */}
          <div className="airport-service-level-fields flex-1 ">
            <label>Reason</label>
            <input
              type="text"
              name="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>

        {/* Map Container */}
        <div className="manual-event-trigger-no-show-map-box">
          <GoogleMapReact
            bootstrapURLKeys={{ key: apiKey }}
            center={coordinates}
            defaultZoom={zoom}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={handleApiLoaded}
            onClick={handleMapClick}
          />
        </div>

        <div className="manual-event-trigger-no-show-image-section">
          <label>Upload Images</label>
          <div className="manual-event-trigger-no-show-upload-grid">
            <label className="manual-event-trigger-no-show-upload-box">
              <span className="manual-event-trigger-no-show-plus">+</span>
              <span>Upload</span>
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={handleImageChange}
                hidden
              />
            </label>

            {images.map((img, index) => (
              <div
                key={index}
                className="manual-event-trigger-no-show-preview-card"
              >
                <img src={img.preview} alt="preview" />
                <button
                  type="button"
                  className="manual-event-trigger-no-show-delete-btn"
                  onClick={() => removeImage(index)}
                >
                  &times;
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="manual-event-trigger-no-show-btn-wrapper">
          <MOButtonV2
            type="submit"
            disabled={loading}
            text={"SUBMIT"}
            textColor="#ffffff"
            radius={4}
            widthSize={137}
            height={36}
            padding={"10px 12px"}
            backgroundColor="#29AEE6"
            fontSize={11}
            onClick={async () => {
              try {
                if (!reason.trim()) {
                  toastMessage("error", "Please provide a reason.");
                  return;
                }

                const uploadPromises = images.map((img) =>
                  uploadImageToAWS(img.file),
                );

                const imageUrls = await Promise.all(uploadPromises);

                apiCall(
                  eventDetail,
                  bookingDetail.id,
                  coordinates.lat,
                  coordinates.lng,
                  reason,
                  imageUrls,
                );
              } catch (error) {
                console.error("Submission failed during image upload:", error);
              }
            }}
          />
        </div>
      </div>
    </MOModalWrapper>
  );
};

export default NoShowReportModal;
